import { render, staticRenderFns } from "./StockCrud.vue?vue&type=template&id=70d13f94&"
import script from "./StockCrud.vue?vue&type=script&lang=js&"
export * from "./StockCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports